import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=5aee77bb&scoped=true&"
import script from "./bank.vue?vue&type=script&lang=js&"
export * from "./bank.vue?vue&type=script&lang=js&"
import style0 from "./bank.vue?vue&type=style&index=0&id=5aee77bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee77bb",
  null
  
)

export default component.exports